import _ from 'lodash';
import { useContext, useState } from 'react';
import LegoAdminPageContext from '../../legoAdminPageContext';
import BadgeId from '../../../components/common/BadgeId';
import useAsyncEffect from '../../../components/common/react-hooks/useAsyncEffect';
import { PaginationLimit } from '../../../components/common/PaginationLimit';
import FragmentsPreview from './FragmentsPreview';
import { IconButton } from '../../../components/common/IconButton';
import InputRegexFilter from '../../../components/common/editors/InputRegexFilter';

export default function FragmentsUsingSpec({ path, specsGroupId = null }) {
  const { page } = useContext(LegoAdminPageContext);

  const [fragments, setFragments] = useState(null);
  const [limit, setLimit] = useState(50);
  const [filter, setFilter] = useState('');

  let cleanPath = path.replaceAll(/^properties\.|\.properties\b/g, '');
  let pathRegexStr = `^${_.escapeRegExp(cleanPath)}(\$|\\.)`.replace(/\bvaluesType\b/g, '\\w+').replace(/\bitems\b/g, '\\d+');
  let pathRegex = new RegExp(pathRegexStr);

  useAsyncEffect(async () => {
    console.log('cleanPath', cleanPath);

    await page.runAsync(async () => {
      const query = { factoidText: pathRegexStr, $populate: true, $limit: limit };
      if (specsGroupId) {
        query.specsGroupIds = specsGroupId;
      }
      let res = await page.service('services/cerokm/sourcefragment').find({ query });
      setFragments(res);
    });
  }, [path, limit]);

  let filteredFragments = fragments;
  if(filter) {
    filteredFragments = filteredFragments.filter(f => f.text.match(filter));
  }

  return <div>
    <div className='d-flex justify-content-between align-items-center mb-2' style={{ gap: '10px' }}>
      <div className='h6'>
        {fragments === null ? 'Loading...' : <><span className='text-secondary'>{fragments.length} fragments setting </span><span className='text-primary monospace'>'{cleanPath}'</span></>}
      </div>

      <InputRegexFilter value={filter} placeholder='Filter...' onChange={setFilter} className='w-25' />

      <PaginationLimit value={limit} onChange={setLimit} />
    </div>

    { fragments && <FragmentsPreview fragments={filteredFragments} specRegex={pathRegex} /> }
  </div>
}
